import { Injectable } from '@angular/core';

import { doc, docData, collection, collectionData, Firestore, query, orderBy, where, limit, addDoc, updateDoc, deleteDoc, setDoc, deleteField, getDocs, collectionGroup, writeBatch, startAfter } from '@angular/fire/firestore';

import { map } from 'rxjs/operators';

import { Sms } from '../classes/index';

@Injectable()
export class SmsService {

	constructor(private firestore: Firestore) {
		console.log('SmsService initialization...');
	}

	listSms(teamId){
		return collectionData(query(collection(this.firestore, 'sms'), where('teamId', '==', teamId), orderBy('time', 'desc')), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(data => {
				let sms = new Sms();
				sms.fromJSON(data);
				return sms;
			});
		}));
	}

	addSms(sms) {
		return addDoc(collection(this.firestore, 'sms'), {...sms});
	}

	deleteSms(smsId) {
		return deleteDoc(doc(this.firestore, 'sms', smsId));
	}

	updateSms(smsId, data){
		return updateDoc(doc(this.firestore, 'sms', smsId), data);
	}
}
